import { render, staticRenderFns } from "./SaveEmployeeButton.vue?vue&type=template&id=686705be&scoped=true"
import script from "./SaveEmployeeButton.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686705be",
  null
  
)

export default component.exports